import {Helmet} from 'react-helmet';

function Python() {
    return (
        <div data-pym-src="https://www.jdoodle.com/embed/v0/49om" className="python">
             <Helmet>
             <script src="https://www.jdoodle.com/assets/jdoodle-pym.min.js" type="text/javascript"></script>   
             </Helmet>
        </div>
    )
}

export default Python;
